import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Grow,
  AppBar,
  Toolbar,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  getDialogBoxHeader,
  getIntlTranslation,
} from "../../../../../utils/helper";
import SaveButton from "../../../../../components/buttons/SaveButton";
import { getBuildingType } from "../../../../../api/suggestionApi";
import { updateMonitoringSubAsset } from "../../../../../api/assetOverviewApi";
import { resetState } from "../../../../component-bundle/asset-overview/assetOverviewSlice";
import { useSnackbar } from "notistack";
import SubAssetCreateForm from "./SubAssetCreateForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow direction="up" ref={ref} {...props} />;
});

const SubAssetCreateContainer = (props) => {
  const scope = useSelector((state) => state.container.scope);
  const state = useSelector((state) => state.assetOverview);
  const formRef = useRef();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const suggestionState = useSelector((state) => state.suggestions);
  const [buildingType, setBuildingType] = useState([]);
  const [createAnother, setCreateAnother] = useState(false);
  const [intialFormData, setIntialFormData] = useState({
    subAssets: [
      {
        id: Date.now(),
        name: "",
        typeOfUse: { title: "", value: null },
        addressLabel: "",
        isGeneral: false,
        order: 1,
        addressCheckbox: true,
        assetIdent: "",
      },
    ],
  });

  useEffect(() => {
    dispatch(getBuildingType());
  }, [dispatch]);

  useEffect(() => {
    if (!!props.data) {
      let tempObj = props.data;
      let found = buildingType.find(
        (f) =>
          f.value === tempObj.typeOfUse &&
          f.language === scope.projectLanguageCode
      )
      setIntialFormData({
        subAssets: [
          {
            name: tempObj.name,
            typeOfUse: !!found ? found : {title: tempObj.typeOfUse, value: tempObj.typeOfUse},
            addressLabel: tempObj.address,
            isGeneral: tempObj.general,
            addressCheckbox: false,
            assetIdent: tempObj.assetIdent,
            subAssetIdent: tempObj.subAssetIdent,
          },
        ],
      });
    }
  }, [
    buildingType,
    props.data,
    scope.projectLanguageCode,
    state.fetchAsset.data,
    state.fetchAsset.type,
  ]);

  useEffect(() => {
    if (
      suggestionState.buildingType.type === "FETCHED" &&
      suggestionState.buildingType.data.length > 0
    ) {
      setBuildingType([...suggestionState.buildingType.data]);
    }
  }, [suggestionState.buildingType]);

  useEffect(() => {
    if (state.createSubAsset.type === "UPDATED") {
      state.createSubAsset.messages.forEach((element) => {
        enqueueSnackbar(element, {
          variant: "success",
          autoHideDuration: 2000,
        });
      });
      props.onUpdate();
      props.onClose();
      dispatch(resetState());
    }
  }, [
    createAnother,
    dispatch,
    enqueueSnackbar,
    props,
    state.create.messages,
    state.createSubAsset,
  ]);

  const handleSave = (values) => {
    const subAssets = values.subAssets.map((s) => {
      return {
        type: "monitoringSubAsset",
        name: s.name,
        typeOfUse: s.typeOfUse.value,
        address: s.addressLabel,
        projectIdent: scope.projectIdent,
        assetIdent: s.assetIdent,
        general: s.isGeneral,
        subAssetIdent:s.subAssetIdent,
      };
    });

    dispatch(
      updateMonitoringSubAsset({
        data: subAssets[0],
        api: scope.api,
      })
    );
  };
  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      fullWidth={true}
      maxWidth={"md"}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          props.onClose();
        }
      }}
      disableBackdropClick
      disableEscapeKeyDown
      style={{ overflow: "hidden" }}
    >
      <AppBar className={"appBar"}>
        <Toolbar className={"dialog-toolbar"}>
          {getDialogBoxHeader("Sub-Asset")}
          <IconButton
            edge="start"
            color="inherit"
            id="create_asset_close"
            onClick={(e) => props.onClose()}
            style={{ marginLeft: "auto" }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent dividers>
        <SubAssetCreateForm
          intialFormData={intialFormData}
          generalExist={props.data.general}
          handleSave={(values) => handleSave(values)}
          formRef={formRef}
          editDialog={true}
          buildingType={buildingType}
        />
      </DialogContent>
      <DialogActions
        className="justify-content-between"
        style={{ marginLeft: "auto" }}
      >
        <SaveButton
          id="create-sub-asset-button"
          buttonText="_create"
          variant="button"
          style={{ margin: 5 }}
          editDialog={false}
          tooltip={{
            title: getIntlTranslation("tooltip.save"),
          }}
          handleClick={(e) => formRef.current.handleSubmit()}
        />
      </DialogActions>
    </Dialog>
  );
};

SubAssetCreateContainer.defaultProps = {
  readOnly: false,
};
SubAssetCreateContainer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  readOnly: PropTypes.bool,
  onCreate: PropTypes.func,
  data: PropTypes.object,
  onUpdate:PropTypes.func,
};

export default SubAssetCreateContainer;
